module.exports = __webpack_public_path__ + "img/2021-CallFinder-Logo-WEB-White-Alt.f59142c0.svg";